import script from "./UpdateTiktokNum.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpdateTiktokNum.vue?vue&type=script&lang=ts&setup=true"

import "./UpdateTiktokNum.vue?vue&type=style&index=0&id=5f227314&lang=scss"

const __exports__ = script;

export default __exports__